export interface ToolSEO {
  title: string;
  description: string;
  keywords: string;
}

export const toolSEOData: Record<string, ToolSEO> = {
  '/': {
    title: 'Free Web3 Developer Toolkit',
    description: 'ByteScan offers 30+ free Web3 developer tools: ENS lookup, ABI encoder/decoder, gas tracker, contract security scanner, unit converters, and more Ethereum utilities.',
    keywords: 'web3 tools, ethereum developer tools, blockchain toolkit, free crypto tools',
  },
  '/ens-lookup': {
    title: 'ENS Lookup',
    description: 'Free ENS name resolver. Look up Ethereum Name Service domains, resolve .eth names to addresses, reverse lookup addresses to ENS names with avatar and content hash.',
    keywords: 'ENS lookup, ethereum name service, .eth domain resolver, ENS reverse lookup, ENS address',
  },
  '/address-validator': {
    title: 'Ethereum Address Validator',
    description: 'Validate Ethereum addresses with checksum verification. Check if an address is valid, verify EIP-55 checksums, detect contract vs EOA, and check balances.',
    keywords: 'ethereum address validator, EIP-55 checksum, validate eth address, ethereum address checker',
  },
  '/balance-checker': {
    title: 'ETH Balance Checker',
    description: 'Check Ethereum wallet balances across multiple chains. View ETH and ERC-20 token balances for any address on Ethereum, Polygon, and Arbitrum.',
    keywords: 'ethereum balance checker, eth wallet balance, check token balance, multi-chain balance',
  },
  '/abi-encoder-decoder': {
    title: 'ABI Encoder/Decoder',
    description: 'Encode and decode Ethereum smart contract ABI data. Parse function signatures, encode calldata, decode transaction inputs and event logs.',
    keywords: 'ABI encoder, ABI decoder, ethereum calldata, smart contract ABI, function signature',
  },
  '/contract-verification-helper': {
    title: 'Contract Verification Helper',
    description: 'Prepare Solidity smart contracts for Etherscan verification. Generate flattened source code, constructor arguments, and verification parameters.',
    keywords: 'etherscan verification, verify smart contract, solidity verification, contract source code',
  },
  '/contract-read-write': {
    title: 'Contract Read/Write UI',
    description: 'Interact with Ethereum smart contracts directly from your browser. Read contract state and write transactions using MetaMask with any ABI.',
    keywords: 'interact smart contract, read contract, write contract, metamask contract interaction',
  },
  '/eth-unit-converter': {
    title: 'Ether Unit Converter',
    description: 'Convert between Wei, Gwei, and ETH instantly. Free online Ethereum unit conversion tool for Web3 developers with real-time calculations.',
    keywords: 'wei to eth, gwei to eth, ethereum unit converter, wei converter, gwei converter',
  },
  '/token-conversion': {
    title: 'Token Unit Converter',
    description: 'Convert ERC-20 token amounts between raw units and human-readable values. Support for any decimal precision from 0 to 18 decimals.',
    keywords: 'token unit converter, ERC-20 decimals, token amount converter, crypto unit conversion',
  },
  '/epoch-conversion': {
    title: 'Unix/UTC Time Converter',
    description: 'Convert Unix timestamps to human-readable dates and vice versa. Support for seconds, milliseconds, and multiple date formats.',
    keywords: 'unix timestamp converter, epoch converter, unix to date, timestamp to date, UTC converter',
  },
  '/base-conversion': {
    title: 'Number Base Converter',
    description: 'Convert numbers between decimal, hexadecimal, binary, and octal. Useful for smart contract development and low-level programming.',
    keywords: 'hex converter, binary converter, decimal to hex, base conversion, number system converter',
  },
  '/string-bytes32': {
    title: 'String to Bytes32 Converter',
    description: 'Convert strings to Solidity bytes32 format and back. Essential for smart contract development with fixed-size byte arrays.',
    keywords: 'string to bytes32, solidity bytes32, bytes32 converter, ethereum bytes encoding',
  },
  '/url-encoder': {
    title: 'URL Encoder & Decoder',
    description: 'Encode and decode URL components online. Handle special characters, query parameters, and URI encoding for web development.',
    keywords: 'URL encoder, URL decoder, percent encoding, URI encode, encodeURIComponent',
  },
  '/eth-block-time': {
    title: 'Ethereum Block Time Converter',
    description: 'Convert Ethereum block numbers to timestamps and estimate block numbers for future dates. Track block production across networks.',
    keywords: 'ethereum block time, block to timestamp, block number converter, ethereum block explorer',
  },
  '/calldata-decoder': {
    title: 'Calldata Decoder',
    description: 'Decode raw Ethereum transaction calldata into readable function calls and parameters. Supports standard and custom ABI signatures.',
    keywords: 'calldata decoder, ethereum calldata, decode transaction input, function selector decoder',
  },
  '/event-decoder': {
    title: 'Event Log Decoder',
    description: 'Decode Ethereum event logs from transaction receipts. Parse topics and data fields into readable event parameters.',
    keywords: 'event log decoder, ethereum events, decode topics, transaction receipt parser',
  },
  '/jwt-decoder': {
    title: 'JWT Decoder',
    description: 'Decode and inspect JSON Web Tokens online. View header, payload, and signature. Verify JWT claims and expiration dates.',
    keywords: 'JWT decoder, JSON web token, decode JWT, JWT parser, token inspector',
  },
  '/transaction-decoder': {
    title: 'Ethereum Transaction Decoder',
    description: 'Decode and analyze Ethereum transactions. View sender, recipient, value, gas details, and decoded input data for any transaction hash.',
    keywords: 'transaction decoder, ethereum tx decoder, decode transaction, eth transaction analyzer',
  },
  '/constructor-encoder': {
    title: 'Contract Constructor Encoder',
    description: 'Encode constructor parameters for Solidity smart contract deployment. Generate ABI-encoded constructor arguments for Etherscan verification.',
    keywords: 'constructor encoder, ABI encode constructor, solidity constructor, contract deployment args',
  },
  '/vanity-address': {
    title: 'Ethereum Vanity Address Generator',
    description: 'Generate custom Ethereum addresses with chosen prefixes or suffixes. Create memorable wallet addresses with specific hex patterns.',
    keywords: 'vanity address, ethereum address generator, custom eth address, vanity wallet',
  },
  '/uuid-generator': {
    title: 'UUID Generator',
    description: 'Generate UUIDs in v1, v4, and v5 formats. Create unique identifiers for databases, APIs, and distributed systems.',
    keywords: 'UUID generator, generate UUID, UUID v4, unique identifier, GUID generator',
  },
  '/hash-generator': {
    title: 'Hash Generator',
    description: 'Generate MD5, SHA-1, SHA-256, SHA-512, and Keccak-256 hashes online. Compute cryptographic hashes for strings and files.',
    keywords: 'hash generator, SHA-256, MD5 hash, keccak256, cryptographic hash, online hash',
  },
  '/qr-generator': {
    title: 'QR Code Generator',
    description: 'Create QR codes for Ethereum addresses, URLs, text, and custom data. Customize colors, size, and error correction level.',
    keywords: 'QR code generator, create QR code, ethereum QR code, address QR code',
  },
  '/random-generator': {
    title: 'Random Data Generator',
    description: 'Generate random test data for development and testing. Create names, emails, addresses, phone numbers, and structured JSON data.',
    keywords: 'random data generator, test data, mock data, fake data generator, random JSON',
  },
  '/random-text-generator': {
    title: 'Random Text Generator',
    description: 'Generate Lorem Ipsum and placeholder text for design mockups. Create paragraphs, sentences, and words of random text.',
    keywords: 'lorem ipsum generator, random text, placeholder text, dummy text generator',
  },
  '/json-formatter': {
    title: 'JSON Formatter & Validator',
    description: 'Format, validate, and beautify JSON data online. Minify JSON, fix formatting issues, and inspect nested structures with syntax highlighting.',
    keywords: 'JSON formatter, JSON validator, beautify JSON, format JSON online, JSON pretty print',
  },
  '/minifier': {
    title: 'Code Minifier & Beautifier',
    description: 'Minify or beautify JavaScript, CSS, and HTML code online. Reduce file sizes or format code for readability.',
    keywords: 'code minifier, JavaScript beautifier, CSS minifier, HTML formatter, code beautifier',
  },
  '/regex-tester': {
    title: 'Regex Tester',
    description: 'Test and debug regular expressions with live matching and highlighting. Support for JavaScript regex flags and capture groups.',
    keywords: 'regex tester, regular expression tester, regex debugger, regex online, pattern matching',
  },
  '/http-builder': {
    title: 'HTTP Request Builder',
    description: 'Build and test HTTP API requests online. Send GET, POST, PUT, DELETE requests with custom headers, body, and query parameters.',
    keywords: 'HTTP request builder, API tester, REST client, test API online, HTTP client',
  },
  '/color-picker': {
    title: 'Color Picker & Converter',
    description: 'Pick colors and convert between HEX, RGB, HSL, and CMYK formats. Use the color wheel, sliders, or input values directly.',
    keywords: 'color picker, hex to rgb, color converter, HSL color, CSS color picker',
  },
  '/clipboard-inspector': {
    title: 'Clipboard Inspector',
    description: 'Inspect and analyze clipboard contents including text, HTML, images, and metadata. Detect content types and security issues.',
    keywords: 'clipboard inspector, clipboard viewer, analyze clipboard, clipboard content',
  },
  '/emoji-picker': {
    title: 'Emoji Picker',
    description: 'Browse and copy emojis organized by category. Search for emojis by name or keyword with one-click copy to clipboard.',
    keywords: 'emoji picker, copy emoji, emoji search, emoji list, unicode emoji',
  },
  '/gas-price-tracker': {
    title: 'Ethereum Gas Price Tracker',
    description: 'Monitor real-time Ethereum gas prices across multiple chains. Track slow, standard, fast, and instant gas costs in Gwei and USD.',
    keywords: 'gas price tracker, ethereum gas, gwei price, gas fees, eth gas tracker, gas estimator',
  },
  '/mev-bot-builder': {
    title: 'MEV Bot Simulator',
    description: 'Simulate MEV (Maximal Extractable Value) strategies with real market data. Educational tool for understanding arbitrage, sandwich, and liquidation strategies.',
    keywords: 'MEV bot simulator, MEV strategy, arbitrage bot, sandwich attack, DeFi MEV, flashbot',
  },
  '/contract-security-scanner': {
    title: 'Smart Contract Security Scanner',
    description: 'Scan Solidity smart contracts for common vulnerabilities. Detect reentrancy, overflow, access control issues, and other security risks.',
    keywords: 'smart contract security, solidity scanner, contract audit, vulnerability scanner, reentrancy check',
  },
};

export function getToolSEO(path: string): ToolSEO {
  return toolSEOData[path] || {
    title: 'ByteScan',
    description: 'Free Web3 developer toolkit with 30+ tools for Ethereum developers.',
    keywords: 'web3 tools, ethereum, blockchain',
  };
}
